import { NewHotelExperienceTypes } from '@/redux/actions/actions.types'

export const setNewHotelUIEnabled = (enabled: boolean) => ({
	type: NewHotelExperienceTypes.SetNewHotelUIEnabled,
	payload: enabled,
})
